import TemplatePreviewCard from './TemplatePreviewCard';

export default TemplatePreviewCard;
